import { Meta, theme } from 'aimo-ui';
import Icon from 'components/icons/Icon';
import React from 'react';
import styled from 'styled-components/native';
import { CenterVerticalRow, StyledWrapper } from 'styles/ContainerStyles';
import { testIdentifiers } from 'utils/testIdentifiers';

interface SuccessIndicatorProps {
  message: string;
  testID?: string;
}

const IconWrapper = styled.View`
  margin-right: 8px;
`;

const MessageText = styled(Meta)`
  font-size: 18px;
`;

const SuccessIndicator: React.FC<SuccessIndicatorProps> = ({
  message,
  testID,
}) => (
  <StyledWrapper mb={30} alignItems="flex-start">
    <CenterVerticalRow>
      <IconWrapper>
        <Icon
          name="check"
          size="m"
          {...testIdentifiers(testID ?? 'success-indicator')}
          color={theme.colors.boost.green}
        />
      </IconWrapper>
      <MessageText>{message}</MessageText>
    </CenterVerticalRow>
  </StyledWrapper>
);

export default SuccessIndicator;
